<section class="perfil-usuario">
  <input #seletorFoto type="file" accept="image/*" hidden (change)="selecionarFoto($event)">
  <div class="perfil-usuario__foto-container">
    <div class="perfil-usuario__foto" (click)="seletorFoto.click()" role="button" tabindex="0"
      (keydown.enter)="seletorFoto.click()" aria-label="Alterar imagem de perfil">
      <img *ngIf="fotoPerfilDisponivel" [src]="'/api/Usuarios/MinhaFotoPerfil?v=' + fotoPerfilVersao"
        (error)="onErroFotoPerfil()" alt="Imagem de perfil">
      <span *ngIf="!fotoPerfilDisponivel">{{ iniciaisUsuario() }}</span>
      <mat-icon class="perfil-usuario__camera">photo_camera</mat-icon>
    </div>
    <button *ngIf="fotoPerfilDisponivel" type="button" class="perfil-usuario__remover" (click)="removerFoto($event)"
      [disabled]="removendoFoto">Remover imagem</button>
  </div>
  <h2>{{ nome }}</h2>
  <p *ngIf="data.administrador" class="perfil-usuario__base">{{ nomeBaseDados }}</p>
  <mat-divider></mat-divider>
  <div class="perfil-usuario__acoes">
    <button mat-icon-button type="button" (click)="abrirSenha()" matTooltip="Alterar senha"
      aria-label="Alterar senha"><mat-icon>key</mat-icon></button>
    <button mat-icon-button type="button" (click)="abrirDados()" matTooltip="Alterar dados"
      aria-label="Alterar dados"><mat-icon>edit</mat-icon></button>
    <button mat-icon-button type="button" (click)="sair()" matTooltip="Sair"
      aria-label="Sair"><mat-icon>logout</mat-icon></button>
  </div>
</section>